import { render, staticRenderFns } from "./Paciente.vue?vue&type=template&id=830619c0&"
import script from "./Paciente.vue?vue&type=script&lang=js&"
export * from "./Paciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports